export default {
      id: "voxys-usage",
      viewBox: "0 0 100 24",
      url: "assets/" + "sprite.svg#voxys-usage",
      toString: function () {
        return this.url;
      }
    }